"use client";

import { c as _c } from "react/compiler-runtime";
import type { PersonContent } from "@/types/person";
import type { SearchPersonResult } from "@/types/search";
import VirtuosoMainCard from "@/components/virtuosomaincard/VirtuosoMainCard";
import { SliderSkeleton } from '@/components/pages/home/loading';
import Button from "@/components/ui/Button";
import SearchPersonCard from "./SearchPersonCard";
interface SearchResultsProps {
  items: PersonContent[];
  loading: boolean;
  hasMore: boolean;
  isLoadingMore: boolean;
  onLoadMore: () => void;
  // Optional so every other caller of SearchResults (unrelated to the
  // /search-backed text query) keeps working unchanged.
  persons?: SearchPersonResult[];
  isError?: boolean;
  onRetry?: () => void;
}
export default function SearchResults(t0) {
  const $ = _c(19);
  const {
    items,
    loading,
    hasMore,
    isLoadingMore,
    onLoadMore,
    persons: t1,
    isError: t2,
    onRetry
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const persons = t3;
  const isError = t2 === undefined ? false : t2;
  if (loading) {
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <SliderSkeleton />;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  if (isError) {
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <span>خطا در دریافت نتایج جستجو</span>;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== onRetry) {
      t5 = onRetry && <Button variant="secondary" size="sm" onClick={onRetry}>تلاش دوباره</Button>;
      $[4] = onRetry;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== t5) {
      t6 = <div className="rounded-xl bg-white/5 p-4 text-sm text-red-300 flex flex-col items-center gap-3 text-center">{t4}{t5}</div>;
      $[6] = t5;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    return t6;
  }
  if (!items.length && !persons.length) {
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="text-center text-sm text-gray-400 py-6">نتیجه‌ای پیدا نشد.</div>;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  let t4;
  if ($[9] !== persons) {
    t4 = persons.length > 0 && <div className="flex flex-wrap gap-3 pt-3 pb-2">{persons.map(_temp)}</div>;
    $[9] = persons;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== hasMore || $[12] !== isLoadingMore || $[13] !== items || $[14] !== onLoadMore) {
    t5 = items.length > 0 && <VirtuosoMainCard data={items} hasMore={hasMore} isLoadingMore={isLoadingMore} onLoadMore={onLoadMore} />;
    $[11] = hasMore;
    $[12] = isLoadingMore;
    $[13] = items;
    $[14] = onLoadMore;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}
function _temp(person, idx) {
  return <SearchPersonCard key={`${person.uuid}-${idx}`} person={person} />;
}